import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';

import IconArrowHeadBottom from 'components/icons/IconArrowHeadBottom';

const styles = theme => ({
  iconArrowHeadBottom: {
    width: 12,
    height: 7.4,
  },
  expansionPanelSummaryContent: {
    minWidth: 20,
    justifyContent: 'flex-end',
  },
  expansionPanelRoot: {
    backgroundColor: 'transparent',
  },
  expansionPanelSummaryRoot: {
    minHeight: 37,
    height: 37,
  },
  expansionPanelSummaryExpandIcon: {
    color: theme.palette.primary[500],
  },
});

const ClaimsFilterExpansionSummary = ({
  expanded,
  onChange,
  filtersLength,
  classes,
}) => (
  <ExpansionPanel
    classes={{
      root: classes.expansionPanelRoot,
    }}
    expanded={expanded}
    elevation={0}
    {...onChange && filtersLength > 0 ? { onChange } : {}}
  >
    <ExpansionPanelSummary
      expandIcon={
        <IconArrowHeadBottom className={classes.iconArrowHeadBottom} />
      }
      classes={{
        root: classes.expansionPanelSummaryRoot,
        content: classes.expansionPanelSummaryContent,
        expandIcon: classes.expansionPanelSummaryExpandIcon,
      }}
    >
      {filtersLength > 0 &&
        <Typography
          color="secondary"
          component="span"
        >
          {filtersLength}
        </Typography>
      }
    </ExpansionPanelSummary>
  </ExpansionPanel>
);

ClaimsFilterExpansionSummary.propTypes = {
  expanded: PropTypes.bool,
  onChange: PropTypes.func,
  filtersLength: PropTypes.number,
  classes: PropTypes.shape({
    iconArrowHeadBottom: PropTypes.string.isRequired,
    expansionPanelSummaryContent: PropTypes.string.isRequired,
    expansionPanelRoot: PropTypes.string.isRequired,
  }).isRequired,
};

ClaimsFilterExpansionSummary.defaultProps = {
  expanded: false,
  onChange: null,
  filtersLength: null,
};

export default withStyles(styles)(ClaimsFilterExpansionSummary);



// WEBPACK FOOTER //
// ./src/components/reports/ClaimsFilter/ClaimsFilterExpansionSummary.js